export default __webpack_public_path__ + "static/andy@2x-424a1e5952479a8aaaac26e734bfc3d5.jpg";